import { MarkerType } from '@xyflow/react';
import { v4 as uuidv4 } from 'uuid';
import CustomNode from '../CustomNode';
import { ConnectEdge } from '../ConnectEdge';
import { FailedEdge } from '../FailedEdge';
import { SuccessEdge } from '../SuccessEdge';
// Added imports for new no-title edge types
import { NoTitleEdge1 } from '../NoTitleEdge1';
import { NoTitleEdge2 } from '../NoTitleEdge2';
import { LoopBackEdge } from '../LoopBackEdge';

export interface NodeEdge {
  id: string;
  source: string;
  target: string;
  type: string;
  animated: boolean;
  style: { stroke: string };
  label: string;
  markerEnd: {
    type: any;
  };
  sourceHandle: string;
}

export const nodeTypes = {
  custom: CustomNode
};

// Added registration of new no-title edge types
export const edgeTypes = {
  onCompleteStep: SuccessEdge,
  onFailedStep: FailedEdge,
  custom: ConnectEdge,
  noTitleEdge1: NoTitleEdge1,
  noTitleEdge2: NoTitleEdge2,
  loopBack: LoopBackEdge
};

export const oneUid = uuidv4();
export const twoUid = uuidv4();

export const initialNodes = [
  {
    id: oneUid,
    type: 'custom',
    position: { x: 0, y: 0 },
    data: {
      id: oneUid,
      label: 'Start App',
      onClick: () => alert(`Clicked on node ${oneUid}`),
      isStart: true
    }
  }
];

export const initialEdges: NodeEdge[] = [
  {
    id: uuidv4(),
    source: oneUid,
    sourceHandle: 'onCompleteStep',
    target: twoUid,
    type: 'onCompleteStep',
    label: 'onCompleteStep',
    animated: false,
    style: { stroke: 'red' },
    markerEnd: {
      type: MarkerType.Arrow
    }
  }
];
